import React, { useEffect } from 'react';
import './SpecializedServices.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

const SpecializedServices = ({ servicesContent = {} }) => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    // Function to group cards into rows
    const groupCardsIntoRows = (cards) => {
        if (!cards) return [];
        
        const rows = [];
        for (let i = 0; i < cards.length; i += 3) {
            const row = cards.slice(i, i + 3);
            rows.push(row);
        }
        return rows;
    };

    const cardRows = groupCardsIntoRows(servicesContent.cards);

    return (
        <section className="specialized-services">
            <div className="container">
                <h2 className="section-title text-center" data-aos="fade-up">
                    {servicesContent.title}
                </h2>
                
                <div className="services-grid">
                    {cardRows.map((row, rowIndex) => (
                        <div key={rowIndex} className="services-row" data-aos="fade-up" data-aos-delay={rowIndex * 100}>
                            {row.map((card, cardIndex) => (
                                <div key={cardIndex} className="service-card-wrapper">
                                    <div className="service-card">
                                        <div className="icon-wrapper">
                                            <img src={card.icon} alt={card.title} className="service-icon" />
                                        </div>
                                        <h3 className="card-title">{card.title}</h3>
                                        <p className="card-description">{card.description}</p>
                                        <button className="explore-btn">
                                            {card.buttonText}
                                            <span className="arrow">→</span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SpecializedServices; 